import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { combineLatest } from 'rxjs';

import { ExchangeLinkComponent } from '@features/exchange-link/exchange-link.component';

import { ToggleComponent } from '@shared/components/toggle/toggle.component';
import { EventType } from '@shared/services/gql.service';
import {
  BudgetCurrencyState,
  BudgetCurrencyType,
} from '@shared/store/budget-currency/budget-currency.model';
import { BudgetCurrencyStore } from '@shared/store/budget-currency/budget-currency.store';
import { EventService } from '@shared/store/event/event.service';
import { MainQuery } from '@shared/store/main/main.query';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ToggleComponent, ExchangeLinkComponent],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleBudgetCurrencyComponent),
    },
  ],
  selector: 'aux-toggle-budget-currency',
  template: `
    <div class="flex items-center">
      <div class="flex items-center space-x-2">
        <div>USD</div>
        <aux-toggle [disabled]="disabled" [value]="fc.value" (change)="onInputChange($event)" />
        <div>Vendor Contract Currency</div>
      </div>
      <aux-exchange-link class="ml-4" />
    </div>
  `,
})
export class ToggleBudgetCurrencyComponent extends ToggleComponent {
  private budgetCurrencyStore = inject(BudgetCurrencyStore);
  private eventService = inject(EventService);
  private mainQuery = inject(MainQuery);

  @Input() disabled = false;
  @Output() nameSelectedCurrency = new EventEmitter();

  constructor() {
    super();

    combineLatest([
      this.eventService.select$(EventType.TRIAL_CHANGED),
      this.mainQuery.select('trialKey'),
    ])
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.budgetCurrencyStore.update({ currency: BudgetCurrencyType.VENDOR });
      });
  }

  @Input() onChangeEvent: (isSelected: boolean) => void = () => {};

  onInputChange(event: Event) {
    const valueToUpdateTo = {
      currency: event ? BudgetCurrencyType.VENDOR : BudgetCurrencyType.USD,
    } as BudgetCurrencyState;

    this.nameSelectedCurrency.emit(event ? BudgetCurrencyType.VENDOR : BudgetCurrencyType.USD);
    this.budgetCurrencyStore.update(valueToUpdateTo);
  }
}
